import { getAPI } from "../helpers/httpHelper";
import {
  API_ADMIN_ESTADO_DESVIACION,
  URL_SUPPORT,
} from "../helpers/variableHelper";

export default class EstadoDesviacionService {
  public static getAll = async (token: string, params: any) => {
    try{
    return (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_ESTADO_DESVIACION}/getall`,
        { Authorization: `Bearer ${token}` },
        params
      )
    ).result.data;
  }catch(e){
    
  }
  };
}
